import React from "react";
import { Container } from "../../../components";
import { Text, Heading } from "@telia/teddy";
import _get from "lodash/get";
import { connect, useDispatch } from "react-redux";
import { FORM_ID } from "../../../../../constants";
import PAGES from "../../../../../constants/pages";
import { Form, RootState } from "../../../../../models";
import CreditCheckModal from "../../../checkout/components/molecules/CreditCheckModal/CreditCheckModal";
import DsfMismatchForm from "../../../checkout/components/organisms/DsfMismatchForm/DsfMismatchForm";
import RenderVerification from "../../../checkout/components/organisms/Verification/RenderVerification";
import { chooseTransferOwnerPhoneNumber } from "../../../checkout/state/actions/transferOwnershipActions";
import { sendCode, verifyCodeTransferOwnership } from "../../../checkout/state/actions/verificationActions";
import * as CHECKOUT_AT from "../../../checkout/state/actionTypes";
import { getFormById } from "../../../checkout/state/selectors/formSelectors";
import * as VERIFICATION_SELECTORS from "../../../checkout/state/selectors/verificationSelectors";
import { selectors as LOADING_SELECTORS } from "../../../loading";
import NumberField from "../../components/molecules/NumberField/NumberField";
import TEXT from "../../text-consts";

interface StateProps {
    creditCheckMessage: string;
    isAllowedToProceed: boolean;
    isDsfMismatch: boolean;
    isLoadingPhoneNumberCheck: boolean;
    transferForm: Form;
}

type ConfirmNumberProps = StateProps;

const ConfirmNumber: React.FC<ConfirmNumberProps> = ({
    // Redux (data)
    transferForm,
    isLoadingPhoneNumberCheck,
    isAllowedToProceed,
    creditCheckMessage,
    isDsfMismatch,
}) => {
    const dispatch = useDispatch();

    const selectedPhoneNumber = _get(transferForm, "values.transfer.number", "");

    if (isDsfMismatch) {
        return (
            <DsfMismatchForm
                update={async (firstName, lastName) =>
                    dispatch(chooseTransferOwnerPhoneNumber(selectedPhoneNumber, "", true, firstName, lastName))
                }
            />
        );
    }

    return (
        <Container size="medium" noMargin>
            <Heading variant="title-200" mb="150" as="h2">
                {TEXT.CONFIRM_NUMBER.HEADING}
            </Heading>
            <Text mb="100">{TEXT.CONFIRM_NUMBER.DESCRIPTION}</Text>
            <NumberField
                selectedPhoneNumber={selectedPhoneNumber}
                setSelectedPhoneNumber={async (newSelectedPhoneNumber): Promise<void> =>
                    dispatch(chooseTransferOwnerPhoneNumber(newSelectedPhoneNumber, selectedPhoneNumber))
                }
                labelText={TEXT.CONFIRM_NUMBER.NUMBER_FIELD.LABEL_TEXT}
                placeholder={TEXT.CONFIRM_NUMBER.NUMBER_FIELD.PLACEHOLDER}
                data-di-mask
            />
            {isAllowedToProceed && (
                <RenderVerification
                    isLoadingPhoneNumberCheck={isLoadingPhoneNumberCheck}
                    selectedPhoneNumber={selectedPhoneNumber}
                    sendCode={async (...args): Promise<void> => dispatch(sendCode(...args))}
                    verifyCode={async (...args): Promise<void> => dispatch(verifyCodeTransferOwnership(...args))}
                    data-di-mask
                />
            )}
            <CreditCheckModal
                creditCheckMessage={creditCheckMessage}
                onContinue={(): void => {
                    window.location.assign(PAGES.TRANSFER_OWNERSHIP.SUMMARY.URL);
                }}
            />
        </Container>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    isLoadingPhoneNumberCheck: LOADING_SELECTORS.isTypeLoading(
        state,
        CHECKOUT_AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER_TRANSFER_OWNERSHIP,
    ),
    transferForm: getFormById(state, FORM_ID.TRANSFER_OWNERSHIP),
    creditCheckMessage: VERIFICATION_SELECTORS.creditCheckMessage(state),
    isAllowedToProceed: VERIFICATION_SELECTORS.isAllowedToProceed(state),
    isDsfMismatch: VERIFICATION_SELECTORS.isDsfMismatch(state),
});

export default connect(mapStateToProps)(ConfirmNumber);
